"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/doctorSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type DoctorSectionSlideFadeOutDownsItem = {
    key: Key | null | undefined;
    /** Detected variants: "grid-overlay-item" | "grid-overlay-item d-flex align-items-center justify-content-between" */
    className: string;
    /** Detected variants: "5.0" | "4.6" | "4.8" | "4.2" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/doctor-grid/doctor-grid-01.jpg" | "/Templates/Doccure/img/doctor-grid/doctor-grid-02.jpg" | "/Templates/Doccure/img/doctor-grid/doctor-grid-03.jpg" | "/Templates/Doccure/img/doctor-grid/doctor-grid-04.jpg" | "/Templates/Doccure/img/doctor-grid/doctor-grid-05.jpg" */
    src: string;
    /** Detected variants: "d-flex active-bar" | "active-bar active-bar-pink" | "active-bar active-bar-teal" | "active-bar active-bar-info" */
    div0ClassName: string;
    /** Detected variants: "Psychologist" | "Pediatrician" | "Neurologist" | "Cardiologist" */
    link0Text: ReactNode;
    /** Detected variants: "text-indigo fw-medium fs-14" | "text-pink fw-medium fs-14" | "text-teal fw-medium fs-14" | "text-info fw-medium fs-14" */
    link0ClassName: string;
    /** Detected variants: "#" | "all_routes.booking1" */
    href: string;
    /** Detected variants: "Minneapolis, MN" | "Ogden, IA" | "Winona, MS" | "Beckley, WV" | "Hamshire, TX" */
    p0Text: ReactNode;
    /** Detected variants: "30 Min" | "60 Min" */
    span0Span0Text: ReactNode;
    /** Detected variants: "Dr. Michael Brown" | "Dr. Nicholas Tello" | "Dr. Harold Bryant" | "Dr. Sandra Jones" | "Dr. Charles Scott" */
    link0Link0Text: ReactNode;
    /** Detected variants: "$650" | "$350" | "$500" | "$550" | "$600" */
    div0Text: ReactNode;
    /** Detected variants: "slide-item wow fadeOutDown" */
    divClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "card doctor-item" */
    div0ClassName2?: string;
    /** Detected variants: "card-img card-img-hover" */
    div0ClassName3?: string;
    /** Detected variants: "badge bg-orange" */
    span0ClassName?: string;
    /** Detected variants: "fa-solid fa-star me-1" */
    i0ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
    /** Detected variants: "" */
    alt?: string;
    /** Detected variants: "card-body p-0" */
    div1ClassName?: string;
    /** Detected variants: "Available" */
    span0Span0Text2?: ReactNode;
    /** Detected variants: "badge bg-success-light d-inline-flex align-items-center" */
    span0ClassName2?: string;
    /** Detected variants: "fa-solid fa-circle fs-5 me-1" */
    i0ClassName2?: string;
    /** Detected variants: "doctor-info" */
    div1ClassName2?: string;
    /** Detected variants: "doctor-info-detail" */
    div0ClassName4?: string;
    /** Detected variants: "doctor-location" */
    div0ClassName5?: string;
    /** Detected variants: "fa-solid fa-circle dot" */
    i0ClassName3?: string;
    /** Detected variants: "location-title" */
    p0ClassName?: string;
    /** Detected variants: "isax isax-location me-2" */
    i0ClassName4?: string;
    /** Detected variants: "location-date" */
    span0ClassName3?: string;
    /** Detected variants: "mb-1 custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href2?: string;
    /** Detected variants: "doctor-footer" */
    div1ClassName3?: string;
    /** Detected variants: "price" */
    div0ClassName6?: string;
    /** Detected variants: "Consultation Fees" */
    p0P0Text?: ReactNode;
    /** Detected variants: "mb-1" */
    p0ClassName2?: string;
    /** Detected variants: "btn btn-md book-btn" */
    link0ClassName2?: string;
    /** Detected variants: "all_routes.booking" */
    link0Href3?: string;
    /** Detected variants: "isax isax-calendar-1 icon-1" */
    i0ClassName5?: string;
    /** Detected variants: "isax isax-export-3 icon-2" */
    i1ClassName?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeOneDoctorSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Div1Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Div1Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Featured Doctors" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Doctor" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Highlighted" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    doctorSectionSlideFadeOutDowns: DoctorSectionSlideFadeOutDownsItem[];
    doctorSectionSlideFadeOutDownsItemWrapper?: (item: DoctorSectionSlideFadeOutDownsItem, content: ReactNode) => ReactNode;
    doctorSectionSlideFadeOutDownsRenderer?: (defaultNode: ReactNode) => ReactNode;
    doctorSectionSlideFadeOutDownsLinkVisible?: boolean;
    doctorSectionSlideFadeOutDownsLinkRenderer?: (item: DoctorSectionSlideFadeOutDownsItem, defaultNode: ReactNode) => ReactNode;
    doctorSectionSlideFadeOutDownsImageVisible?: boolean;
    doctorSectionSlideFadeOutDownsImageRenderer?: (item: DoctorSectionSlideFadeOutDownsItem, defaultNode: ReactNode) => ReactNode;
    doctorSectionSlideFadeOutDownsH3Visible?: boolean;
    doctorSectionSlideFadeOutDownsH3Renderer?: (item: DoctorSectionSlideFadeOutDownsItem, defaultNode: ReactNode) => ReactNode;
    doctorSectionSlideFadeOutDownsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    doctorSectionSlideFadeOutDownsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    doctorSectionSlideFadeOutDownsH3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSectionSlideFadeOutDownsItem) => Partial<ComponentProps<"h3">>);
};

const HomeOneDoctorSectionGenerated: FC<HomeOneDoctorSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Featured Doctors",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Our",
    sectionDiv0Div0H20H2Text2 = "Doctor",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Highlighted",
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1Div0Link0LinkProps,
    divDiv0Div1Div1Div0H30H3Props,
    divDiv0Div1Div1Div0H30Link0LinkProps,
    divDiv0Div1Div1Div1Link0LinkProps,
    sectionDiv0Slider0SliderProps,
    doctorSectionSlideFadeOutDowns,
    doctorSectionSlideFadeOutDownsItemWrapper,
    doctorSectionSlideFadeOutDownsRenderer,
    doctorSectionSlideFadeOutDownsLinkVisible,
    doctorSectionSlideFadeOutDownsLinkRenderer,
    doctorSectionSlideFadeOutDownsImageVisible,
    doctorSectionSlideFadeOutDownsImageRenderer,
    doctorSectionSlideFadeOutDownsH3Visible,
    doctorSectionSlideFadeOutDownsH3Renderer,
    doctorSectionSlideFadeOutDownsLinkProps,
    doctorSectionSlideFadeOutDownsImageProps,
    doctorSectionSlideFadeOutDownsH3Props,
}) => {
    return (
        <section className="doctor-section section">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <Slider className="doctors-slider" {...settings} {...(sectionDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        doctorSectionSlideFadeOutDowns,
                        (item: DoctorSectionSlideFadeOutDownsItem) => (
                            <div className={item.divClassName ?? "slide-item wow fadeOutDown"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName2 ?? "card doctor-item"}>
                                    <div className={item.div0ClassName3 ?? "card-img card-img-hover"}>
                                        {renderItemNode(doctorSectionSlideFadeOutDownsLinkVisible, doctorSectionSlideFadeOutDownsLinkRenderer, item, (
                                            <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} {...(typeof doctorSectionSlideFadeOutDownsLinkProps === "function" ? doctorSectionSlideFadeOutDownsLinkProps(item) : (doctorSectionSlideFadeOutDownsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(doctorSectionSlideFadeOutDownsImageVisible, doctorSectionSlideFadeOutDownsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? ""} {...(typeof doctorSectionSlideFadeOutDownsImageProps === "function" ? doctorSectionSlideFadeOutDownsImageProps(item) : (doctorSectionSlideFadeOutDownsImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.className}>
                                            <span className={item.span0ClassName ?? "badge bg-orange"}>
                                                <i className={item.i0ClassName ?? "fa-solid fa-star me-1"} />
                                                {item.span0Text}
                                            </span>
                                            <div data-template-tag="FavIcon" />
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "card-body p-0"}>
                                        <div className={item.div0ClassName}>
                                            {renderItemNode(doctorSectionSlideFadeOutDownsLinkVisible, doctorSectionSlideFadeOutDownsLinkRenderer, item, (
                                                <SmartLink href={item.href} className={item.link0ClassName} {...(typeof doctorSectionSlideFadeOutDownsLinkProps === "function" ? doctorSectionSlideFadeOutDownsLinkProps(item) : (doctorSectionSlideFadeOutDownsLinkProps ?? {}))} {...(typeof divDiv0Div1Div0Link0LinkProps === "function" ? divDiv0Div1Div0Link0LinkProps(item) : (divDiv0Div1Div0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                            <span className={item.span0ClassName2 ?? "badge bg-success-light d-inline-flex align-items-center"}>
                                                <i className={item.i0ClassName2 ?? "fa-solid fa-circle fs-5 me-1"} />
                                                {item.span0Span0Text2 ?? "Available"}
                                            </span>
                                        </div>
                                        <div className={item.div1ClassName2 ?? "doctor-info"}>
                                            <div className={item.div0ClassName4 ?? "doctor-info-detail"}>
                                                {renderItemNode(doctorSectionSlideFadeOutDownsH3Visible, doctorSectionSlideFadeOutDownsH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "mb-1 custom-title"} {...(typeof doctorSectionSlideFadeOutDownsH3Props === "function" ? doctorSectionSlideFadeOutDownsH3Props(item) : (doctorSectionSlideFadeOutDownsH3Props ?? {}))} {...(typeof divDiv0Div1Div1Div0H30H3Props === "function" ? divDiv0Div1Div1Div0H30H3Props(item) : (divDiv0Div1Div1Div0H30H3Props ?? {}))}>
                                                        {renderItemNode(doctorSectionSlideFadeOutDownsLinkVisible, doctorSectionSlideFadeOutDownsLinkRenderer, item, (
                                                            <SmartLink href={item.link0Href2 ?? "all_routes.doctorProfile1"} {...(typeof doctorSectionSlideFadeOutDownsLinkProps === "function" ? doctorSectionSlideFadeOutDownsLinkProps(item) : (doctorSectionSlideFadeOutDownsLinkProps ?? {}))} {...(typeof divDiv0Div1Div1Div0H30Link0LinkProps === "function" ? divDiv0Div1Div1Div0H30Link0LinkProps(item) : (divDiv0Div1Div1Div0H30Link0LinkProps ?? {}))}>{item.link0Link0Text}</SmartLink>
                                                        ))}
                                                    </h3>
                                                ))}
                                                <div className={item.div0ClassName5 ?? "doctor-location"}>
                                                    <p className={item.p0ClassName ?? "location-title"}>
                                                        <i className={item.i0ClassName4 ?? "isax isax-location me-2"} />
                                                        {item.p0Text}
                                                    </p>
                                                    <i className={item.i0ClassName3 ?? "fa-solid fa-circle dot"} />
                                                    <span className={item.span0ClassName3 ?? "location-date"}>{item.span0Span0Text}</span>
                                                </div>
                                            </div>
                                            <div className={item.div1ClassName3 ?? "doctor-footer"}>
                                                <div>
                                                    <p className={item.p0ClassName2 ?? "mb-1"}>{item.p0P0Text ?? "Consultation Fees"}</p>
                                                    <div className={item.div0ClassName6 ?? "price"}>{item.div0Text}</div>
                                                </div>
                                                {renderItemNode(doctorSectionSlideFadeOutDownsLinkVisible, doctorSectionSlideFadeOutDownsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href3 ?? "all_routes.booking"} className={item.link0ClassName2 ?? "btn btn-md book-btn"} {...(typeof doctorSectionSlideFadeOutDownsLinkProps === "function" ? doctorSectionSlideFadeOutDownsLinkProps(item) : (doctorSectionSlideFadeOutDownsLinkProps ?? {}))} {...(typeof divDiv0Div1Div1Div1Link0LinkProps === "function" ? divDiv0Div1Div1Div1Link0LinkProps(item) : (divDiv0Div1Div1Div1Link0LinkProps ?? {}))}>
                                                        <i className={item.i0ClassName5 ?? "isax isax-calendar-1 icon-1"} />
                                                        <i className={item.i1ClassName ?? "isax isax-export-3 icon-2"} />
                                                    </SmartLink>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        doctorSectionSlideFadeOutDownsItemWrapper,
                        doctorSectionSlideFadeOutDownsRenderer
                    )}
                </Slider>
            </div>
        </section>
    );
};

export default HomeOneDoctorSectionGenerated;
